var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google logo"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5037_3406)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.174 9.71046C18.174 8.93159 18.1121 8.36322 17.9782 7.7738H9.27246V11.2892H14.3825C14.2796 12.1629 13.7232 13.4786 12.4869 14.3626L12.4695 14.4803L15.2221 16.6588L15.4128 16.6783C17.1643 15.0258 18.174 12.5944 18.174 9.71046Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.27263 18.9729C11.7761 18.9729 13.8779 18.1308 15.413 16.6783L12.487 14.3627C11.7041 14.9205 10.6532 15.31 9.27263 15.31C6.82061 15.31 4.73948 13.6575 3.99762 11.3735L3.88888 11.383L1.02669 13.6459L0.989258 13.7522C2.51404 16.8467 5.64606 18.9729 9.27263 18.9729Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.9974 11.3736C3.80165 10.7842 3.68836 10.1526 3.68836 9.50004C3.68836 8.84742 3.80165 8.21592 3.9871 7.62651L3.98191 7.50098L1.08385 5.20166L0.989033 5.24774C0.360597 6.53185 0 7.97386 0 9.50004C0 11.0262 0.360597 12.4682 0.989033 13.7523L3.9974 11.3736Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.27263 3.68991C11.0138 3.68991 12.1882 4.45826 12.8579 5.10036L15.4748 2.49004C13.8676 0.963864 11.7761 0.0270996 9.27263 0.0270996C5.64606 0.0270996 2.51404 2.15321 0.989258 5.24766L3.98732 7.62643C4.73949 5.34242 6.82061 3.68991 9.27263 3.68991Z",
    fill: "#EB4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5037_3406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1739,
    height: 19,
    rx: 9.08696,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.26e25ea9efbf29ee03feb2904558c725.svg";
export { ForwardRef as ReactComponent };